import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import { BillingPlanTier } from '@recruitee/products-types';
import {
  RtTooltip,
  IconComponent,
  IconColorDirective,
  HeadingComponent,
} from '@recruitee/user-interface';

import { PlanPickerModel } from '../plan-picker.model';

@Component({
  selector: 'rt-plan-picker-compare',
  templateUrl: './plan-picker-compare.component.html',
  styleUrls: ['./plan-picker-compare.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeadingComponent, IconColorDirective, IconComponent, RtTooltip, TranslatePipe],
})
export class PlanPickerCompareComponent {
  @Input() public highlighted: BillingPlanTier;
  @Input() public active: BillingPlanTier | string;

  public BillingPlanTier = BillingPlanTier;

  constructor(public content: PlanPickerModel) {}

  public trackByIndex(index: number) {
    return index;
  }
}
